<template>
	<fragment>
		<common-header
			subname="상담 관리"
			name="상담통계"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="false"
		></common-header>

		<section ref="container" class="container">
			<common-side-menu :menus="sideMenus"></common-side-menu>
			<div class="container-fiuld class-making-box clearfix" v-if="selectedSurvey">
				<div class="title-box b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">{{selectedSurvey.surveyName}}</div>
					<div class="btn-group pull-right p-10 p-r-0">
						<div v-if="answerList" class="select pull-left m-r-5">
							응답자 수: {{answerList.length}}명 
						</div>
						<div class="select pull-left m-r-5">
							날짜 범위: 
						</div>
						<div class="select pull-left m-r-5">
							<VueCtkDateTimePicker
								:max-date="maxDate"
								:no-value-to-custom-elem="true"
								:only-date="true"
								:format="'YYYY-MM-DD'"
								v-model="startDate"
							>
								<input class="form-control full-width" type="text" :value="startDate"/>
							</VueCtkDateTimePicker>
						</div>
						<div class="select pull-left m-r-5">
							~
						</div>
						<div class="select pull-left m-r-5">
							<VueCtkDateTimePicker
								:min-date="startDate"
								:no-value-to-custom-elem="true"
								:only-date="true"
								:format="'YYYY-MM-DD'"
								v-model="endDate"
							>
								<input class="form-control full-width" type="text" :value="endDate"/>
							</VueCtkDateTimePicker>
						</div>
						<div class="select pull-left m-r-5">
							<button class="btn round w160 pull-right" @click="checkSurveyAppl">확인</button>
						</div>
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" @click="excelDownload">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 액셀 다운로드
							</a>
						</div>
					</div>
				</div>
				<!--
				<div class="white-box clearfix">
					<p class="f-14 m-b-5">설문대상</p>
					<div class="input-group full-width">
						<span class="input-group-addon w180 p-r-5">
							<input class="form-control round m-b-0" type="text"
							:value="`${moment(selectedSurvey.regDate).format('YYYY-MM-DD')} ~ ${moment(selectedSurvey.regDate).format('YYYY-MM-DD')}`" disabled>
						</span>
						<span class="input-group-addon">
							<input class="form-control text-left round m-b-0" type="text" :value="selectedSurvey.target" disabled>
						</span>
					</div>
					<p class="text-right">{{ selectedSurvey.state }}</p>
				</div>
				-->
				<div class="white-box clearfix" v-for="(surveyItem, idx) in selectedSurvey.surveyItemMappingList" :key="`survey-itme-${surveyItem.surveyItemId}`">
					<div class="input-group full-width m-b-15 p-b-10 b-b">
						<span class="input-group-addon w20 v-mid f-16 text-left">{{idx + 1}}.</span>
						<span class="input-group-addon w100 v-mid p-r-5">
							｜ {{ surveyItem.type }} ｜
						</span>
						<span class="input-group-addon v-mid text-left p-r-5">
							{{ surveyItem.itemName }}
						</span>
					</div>
					<template v-if="surveyItem.type === '주관식'">
						<button class="btn-sm round center-block" v-if="answerList" @click="showAnswer(surveyItem)">답변보기</button>
						<div class="text-center" v-else>
							<img class="w480 h480" src="images/ajax_indicator.gif" style="width:200px;" alt="로딩중">
						</div>
					</template>
					<template v-else>
						<div class="col-md-4">
							<div class="input-group full-width m-b-10" v-for="(answer, idx) in surveyItem.child" :key="`survey-itme-${surveyItem.surveyItemId}-child-${answer.surveyItemId}`">
								<span class="input-group-addon w60 v-mid p-r-5">
									<!-- <input :id="`survey-itme-${surveyItem.surveyItemId}-child-${answer.surveyItemId}`" class="checkbox4" type="checkbox" disabled> -->
									<!-- <label :for="`survey-itme-${surveyItem.surveyItemId}-child-${answer.surveyItemId}`" class="sq">체크버튼</label> -->
									<span class="sq" >{{idx + 1}}.</span>
								</span>
								<span class="input-group-addon text-left v-mid p-r-5" style="line-height: 1">
									{{ answer.itemName }}
								</span>
								<span class="input-group-addon text-left v-mid p-r-5" v-if="answerList && answer.type === '작성보기'">
									<button class="btn-sm round" @click="showAnswer(answer)">답변보기</button>
								</span>
							</div>
						</div>
						<div class="col-md-3 b-l" v-if="answerList">
							<div class="input-group full-width m-b-10"  v-for="answer in surveyItem.child" :key="`survey-itme-${surveyItem.surveyItemId}-select-${answer.surveyItemId}`">
								<span class="input-group-addon v-mid p-r-5">
									<div class="progress full-width m-t-0">
										<span class="progress-bar" :style="`width:${getPercent(answer)}%`">{{getPercent(answer)}}%</span>
									</div>
								</span>
								<span class="input-group-addon w60 text-left v-mid">
									{{getSurveyAnswerCount(answer)}}명
								</span>
							</div>
						</div>
						<div class="text-center w480 h480 col-md-3 b-l" v-else>
							<img src="images/ajax_indicator.gif" style="width:200px;" alt="로딩중">
						</div>
						<div class="col-md-5 b-l" v-if="answerList && chartList[surveyItem.surveyItemId]">
							<ChartPie :chart="chartList[surveyItem.surveyItemId]" ref="chart"></ChartPie>
						</div>
						<div class="text-center w480 h480 col-md-5 b-l" v-else>
							<img src="images/ajax_indicator.gif" style="width:200px;" alt="로딩중">
						</div>
					</template>
				</div>

			</div>
				
		</section>

		<modal-survey-answer :config="modals.ModalSurveyAnswer" @close="modals.ModalSurveyAnswer.show=false;"></modal-survey-answer>
		<modal-survey-register
			:config="modals.ModalSurveyRegister"
			:key="'modal-survey-register-'+hash(modals.ModalSurveyRegister)"
			@close="modals.ModalSurveyRegister.show=false;"
			@refresh="refreshData()"></modal-survey-register>
		<modal-survey-register-excel :config="modals.ModalSurveyRegisterExcel" @close="modals.ModalSurveyRegisterExcel.show=false;" :key="'modal-survey-register-excel-'+hash(modals.ModalSurveyRegisterExcel)"></modal-survey-register-excel>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;"></modal-alert>
	</fragment>
</template>

<script>
// import hash from 'hash-object'
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'
import ModalSurveyRegister from '../modals/ModalSurveyRegister.vue'
import ModalSurveyRegisterExcel from '../modals/ModalSurveyRegisterExcel.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import ModalSurveyAnswer from '../modals/ModalSurveyAnswer.vue'
import Axios from 'axios'
import server from '../statics/server'
import ChartPie from '../components/ChartPie'
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import moment from "moment";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

// const cache = { };

export default {
	name: "ViewSurveyAppl",
	mixins: [fnAdjustHeight],
	components: {
		CommonHeader,
		CommonSideMenu,
		ModalSurveyRegister,
		ModalSurveyRegisterExcel,
		ModalAlert,
		ModalSurveyAnswer,
		ChartPie,
		VueCtkDateTimePicker
	},
	mounted: function() {
		this.getSurveyList();
	},
	data: function() {
		return {
			menus: [ // 서브메뉴
				{name:'상담글 목록',link:"/counsel",selected:false},
				{name:"상담통계", link:"/counselStatistics",selected:true}
			],
			buttons: [

			], // 헤더버튼
			sideButtons: [],
			sideMenus: [],
			modals: {
				ModalSurveyAnswer: ModalSurveyAnswer.default(),
				ModalSurveyRegister: ModalSurveyRegister.default(),
				ModalSurveyRegisterExcel: ModalSurveyRegisterExcel.default(),
				ModalAlert: ModalAlert.default(),
			}, // 모달 설정객체 모음
			maxDate : moment(new Date().setDate(new Date().getDate() - 1)).format("YYYY-MM-DD"),
			selectedSurvey: null,
			answerList: null,
			chartList : null,
			startDate : moment(new Date().setFullYear(new Date().getFullYear(),new Date().getMonth(),1)).format("YYYY-MM-DD"),
			endDate : moment(Date.now()).format("YYYY-MM-DD"),
			draw: false
		}
	},
	methods: {
		excelDownload: function() {
			const {startDate,endDate,selectedSurvey} = this;
			const surveyId = selectedSurvey.surveyId;
			Axios.post(server.addr()+server.api.SURVEY_APPL_EXCEL,{
				surveyApplList :[{surveyId}],
				startDate,
				endDate : moment(new Date(endDate).setDate(new Date(endDate).getDate() + 1)).format("YYYY-MM-DD")
			}).then(response => {
				window.open(`${server.addr()}/download/${response.data}`,"", "");
			})
		},
		getSurveyList: async function() {
			try {
				const surveyIdList = [server.counselSurveyId, server.counselReplySurveyId];
				const { data } = await Axios.post(`${server.addr()}${server.api.SURVEY}`, { });
				const surveyList = data.list.filter(survey => surveyIdList.indexOf(survey.surveyId) > -1);
				this.sideMenus = surveyList.map(survey => {
					return {
						name: survey.surveyName,
						fn: () => {
							this.startDate  = moment(new Date().setFullYear(new Date().getFullYear(),new Date().getMonth(),1)).format("YYYY-MM-DD");
							this.endDate = moment(Date.now()).format("YYYY-MM-DD");
							this.setSurvey(survey);
						}
					}
				});
				this.sideMenus[0].fn();
			} catch (e) {
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.msg = "통신 오류입니다. 잠시 후 다시 시도해주세요.";
			}
		},
		setSurvey: async function(survey) {
			try {
				const { startDate, endDate } = this;
				this.selectedSurvey = survey;
				const { data } = await Axios.post(`${server.addr()}${server.api.SURVEY_APPL}`, { 
					surveyId: survey.surveyId,
					startDate,
					endDate : moment(new Date(endDate).setDate(new Date(endDate).getDate() + 1)).format("YYYY-MM-DD")
				});
				this.answerList = data.list;
				const chartList = {};
				this.selectedSurvey.surveyItemMappingList.map(surveyItem => {
					if(surveyItem.child) {
						chartList[surveyItem.surveyItemId] = chartList[surveyItem.surveyItemId] || {labels:[], data:[]};
						const labels = [];
						const data = [];
						surveyItem.child.map(answer => labels.push(answer.itemName));
						surveyItem.child.map(answer => data.push(this.getSurveyAnswerCount(answer)));
						chartList[surveyItem.surveyItemId].labels = labels;
						chartList[surveyItem.surveyItemId].data = data;
					}
				});
				this.chartList = chartList;
				this.draw = true;
			}
			catch(e) {
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.msg = "통신 오류입니다. 잠시 후 다시 시도해주세요.";
			}
		},
		getSurveyAnswerCount: function(surveyItem) {
			let checkCount = 0;
			// if (cache[hash(surveyItem)]) return cache[hash(surveyItem)];
			this.answerList.map(surveyAppl => {
				const surveyAnswer = surveyAppl.surveyItemApplList.find(e =>  e.surveyItemId === surveyItem.surveyItemId);
				if(surveyAnswer) checkCount += 1;
			});
			return checkCount;
		},
		getPercent: function(surveyItem) {
			// // eslint-disable-next-line
			// console.log(this.getSurveyAnswerCount(surveyItem) )
			// console.log(this.answerList.length)
			const percentage = Math.floor(this.getSurveyAnswerCount(surveyItem) / this.answerList.length * 100) || 0;
			return percentage;
		},
		showAnswer: function(surveyItem) {
			let answerValues = [];
			answerValues = this.answerList.map(survey => {
				let ans = "";
				const surveyAnswer = survey.surveyItemApplList.find(e => e.surveyItemId === surveyItem.surveyItemId);
				if(surveyAnswer) ans = surveyAnswer.etcText;
				return ans;
			}).filter(e => e);
			this.modals.ModalSurveyAnswer.show = true;
			this.modals.ModalSurveyAnswer.answerList = answerValues;
			this.modals.ModalSurveyAnswer.answerName = surveyItem.itemName;
		},
		checkSurveyAppl: function() {
			this.answerList = null;
			this.setSurvey(this.selectedSurvey);
		}
	},
	updated() {
		if(this.$refs.chart && this.draw) {
			this.$refs.chart.map(c => c.chartCreate())
			this.draw = false;
		}
	}

}
</script>

<style>

</style>